import Works from './worksList'

export default Works